import TippingTipsLayout from '../Tipping';
import _ from 'lodash';
import { Preloader, ErrorsModal } from "../../utils";
import Radio from "backbone.radio";
import './index.styl';
import { StreakTipsCollection } from "../index";

const
	START_ROUND_STREAK = parseInt(process.env.START_ROUND_STREAK, 10),
	END_ROUND_STREAK = parseInt(process.env.END_ROUND_STREAK, 10),
	BYE_ROUNDS = JSON.parse(process.env.STREAK_BYE_ROUNDS),
	tippingRadio = Radio.channel('tipping');

export class StreakTipsLayout extends TippingTipsLayout {
	get className() {
		return "tipping-tips-layout streak-extend";
	}

	async initialize() {
		this.rounds = this.getOption('rounds');
		this.venues = this.getOption('venues');
		this.squads = this.getOption('squads');
		this.gauntlet = this.getOption('gauntlet');

		this.setListeners();

		Preloader.show();

		await this.getJSON();

		this.current_round = this.getCurrentRound();

		/**
		 * Uncomment this code only in case you want to show placeholder on Streak page.
		 */
		// if (_.lt(this.current_round.id, START_ROUND_STREAK)) {
		// 	Preloader.hide();
		//
		// 	this.trigger('access:denied');
		//
		// 	return this;
		// }

		this.processRounds();

		tippingRadio.trigger('show:controls', {
			rounds: this.rounds,
			current_round: this.current_round
		});

		this.updateStreakInfo();
		this.collection.trigger('user:tips:success');

		Preloader.hide();
	}

	setListeners() {
		super.setListeners();

		this.listenTo(this.gauntlet, 'gauntlet:remove:errors', ErrorsModal.show);
		this.listenTo(this.gauntlet, 'gauntlet:save:errors', ErrorsModal.show);
		this.listenTo(this.gauntlet, 'gauntlet:fetch:errors', ErrorsModal.show);

		this.listenTo(this.gauntlet, 'gauntlet:fetch:success', this.updateStreakInfo);
	}

	changeRound({ round_id }) {
		this.current_round = this.rounds.get(round_id);
		if(!this.current_round){
			return
		}
		console.log(this.rounds, "ROUNDS");
		console.log(round_id, "ROUND");

		tippingRadio.trigger(
			'tips:round:change',
			this.current_round.get('status')
		);

		this.collection.trigger('user:tips:success');
	}

	fetchStats() {
		return this.gauntlet.setSnapshotUrl().getData({
			type: 'gauntlet:fetch'
		});
	}

	childViewEvents() {
		return {
			'squad:add': 'onSquadAdd',
			'squad:remove': 'onSquadRemove',
		}
	}

	async getJSON() {
		const requests = _.invokeMap(
			_.pick(this, 'squads', 'rounds', 'venues', 'gauntlet'),
			'fetch'
		);

		return Promise.all(requests);
	}

	updateStreakInfo() {
		this.collection.trigger('user:tips:success');
		tippingRadio.trigger('streak:update', this.gauntlet.toJSON());

		return this;
	}

	processRounds() {
		this.rounds.reset(
			this.rounds.filter(({ id }) => {
				return(((id >= START_ROUND_STREAK 
          && id <= END_ROUND_STREAK) 
          && !BYE_ROUNDS.includes(id)))
			}
				
			)
		);

		return this;
	}

	extendMatches() {
		const
			isBye = match => BYE_ROUNDS.indexOf(match.round) !== -1,
			isTipDisabled = (match, round_status) => {
				const is_active = this.gauntlet.get('is_active');

				if (isBye(match)) {
					return true;
				}

				return !is_active || !_.eq(round_status, 'scheduled');
			},
			sended = this.gauntlet.get('sended');

		let { matches } = this.current_round.toJSON(),
			selectedTips = _.keyBy(sended, 'predict_winner_squad_id'),
			selectedTipsByMatch = _.keyBy(sended, 'match_id'),
			predict_margin = _.result(
				_.find(sended, { round: this.current_round.id }), 'margin', 0
			),
			extendedMatches = matches.map(match => ({
				...match,
				predict_winner_squad_id: 0,
				is_correct: _.result(selectedTipsByMatch, `[${match.id}].is_correct`, 0),
				is_autogenerate: 0,
				is_complete: match.status === 'complete',
				result_margin: 0,
				hidden: 0,
				is_disabled: isTipDisabled(match, this.current_round.get('status')),
				selected_tips: selectedTips,
				predict_margin,
				home_is_selected: Boolean(selectedTips[match.home_squad_id]),
				home_selected_round_id: _.result(selectedTips, `${match.home_squad_id}.round`),
				is_home_match_end: _.result(selectedTips, `${match.home_squad_id}.is_match_end`),
				is_home_select_correct: (
					!!_.result(selectedTips, `${match.home_squad_id}.is_correct`)
				),
				away_is_selected: Boolean(selectedTips[match.away_squad_id]),
				away_selected_round_id: _.result(selectedTips, `${match.away_squad_id}.round`),
				is_away_match_end: _.result(selectedTips, `${match.away_squad_id}.is_match_end`),
				is_away_select_correct: (
					!!_.result(selectedTips, `${match.away_squad_id}.is_correct`)
				)
			})),
			matches_by_id = _.keyBy(extendedMatches, 'id');

		/**
		 * Mark selected teams
		 */
		_.each(sended, tip => {
			const match = matches_by_id[tip.match_id];

			if (match) {
				match.predict_winner_squad_id = tip.predict_winner_squad_id;
			}
		});

		return matches_by_id;
	}

	getCurrentRound() {
		const activeStreakRound = this.rounds.find(round => 
			(round.get("gauntlet_is_bye") === 0 && round.get("status") === "playing") 
			|| (round.get("gauntlet_is_bye") === 0 && round.get("status") === "scheduled"));
		const activeStreakRoundId = activeStreakRound.get('id');

		const roundToUse = 
      BYE_ROUNDS.includes(this.rounds.actual.id) ? activeStreakRoundId : this.rounds.actual.id;
		
		return this.rounds.get(
			_.max([START_ROUND_STREAK, roundToUse])
		);
	}

	async onSquadAdd(args) {
		Preloader.show();

		const { success } = await this.gauntlet.setSaveUrl().postData({
			data: args,
			type: 'gauntlet:save'
		});

		await this.fetchStats();

		if (success) {
			tippingRadio.trigger('saved');
		}

		Preloader.hide();
	}

	async onSquadRemove(args) {
		Preloader.show();

		const { success } = await this.gauntlet.setRemoveUrl().postData({
			data: args,
			type: 'gauntlet:remove'
		});

		await this.fetchStats();

		if (success) {
			tippingRadio.trigger('saved');
		}

		Preloader.hide();
	}

	initTipsCollection(args) {
		this.getRegion('content').show(new StreakTipsCollection());
		this.getChildView('content').init(args);

		return this;
	}
}

export * from './StreakTip';
export * from './StreakTipsCollection';
export * from './StreakGamebar';
export * from './Placeholder';
export * from './WidgetStreakTracker';

export default StreakTipsLayout;